<template>
	<!-- 预出库单 -->
	<div class="preDeliveryNote">
		<!-- 打印模板 -->
		<div :id="'export-template' + index" v-for="(item, index) in selectionList" :key="index"
			style="position: fixed;top: -9999999px;">
			<div :id="'template-title' + index">
				<div style="line-height: 50px;font-size: 22px;" align=center>
					<strong>
						<font>{{ supplier_info.supplier_name }}配货单</font>
					</strong>
				</div>
				<div style="font-size: 26px;font-weight: 600;left:50px;top:10px;position: absolute;">
					{{ item.phone.slice(-4) }}
				</div>
				<div style="font-size: 26px;font-weight: 600;right:100px;top:10px;position: absolute;">
					{{ item.leader_serial ? item.leader_serial : (index + 1) }}
				</div>
				<table border=0 cellSpacing=0 cellPadding=0 width="90%" style="line-height: 20px;font-size: 14px;">
					<tbody>
						<tr>
							<td style="width:70%">
								<font>提货方式：<span>{{ item.delivery_type == 1 ?
								'配送【' + (item.deliveryline ? item.deliveryline.title : '') + '】,运费' + item.delivery_fee +
								'元,'
								+
								(item.delivery_fee_status == 0 ? '未付' : '已付')
								: '自提' }}</span></font>
							</td>
							<td style="width:30%">
								<font>打印时间：<span>{{ currentDateTime }}</span></font>
							</td>
						</tr>
						<tr>
							<td style="width:70%">
								<font>配货日期：<span>{{ item.date }}</span></font>
							</td>
							<td style="width:30%">
								<font>配送仓库：<span>{{ item.warehouse ? item.warehouse.name : '暂无' }}</span></font>
							</td>

						</tr>
						<tr>
							<td colspan="2">
								<font>收货信息：{{ item.contacts }}-{{ item.phone }}-{{ item.address }}</font>
							</td>
						</tr>
						<tr>
							<td colspan="2">
								<font>备注：{{ item.remark }}</font>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div :id="'template-table' + index">
				<table border=1 cellSpacing=0 cellPadding=1
					:style="'font-size: '+printFontSize+'px;border-collapse:collapse;width:90%'" bordercolor="#333333">
					<thead>
						<tr>
							<td width="10%" style="padding:4px">
								<div align=center><b>序号</b></div>
							</td>
							<td width="20%" style="padding:4px">
								<div align=center><b>商品分类</b></div>
							</td>
							<td width="55%" style="padding:4px">
								<div align=center><b>商品名称</b></div>
							</td>
							<td width="15%" style="padding:4px">
								<div align=center><b>配货数</b></div>
							</td>
						</tr>
					</thead>
					<tbody>
						<div v-for="(itemChil, indexChil) in item.goodsList" :key="indexChil">
							<tr>
								<td align=center style="padding:4px">{{ indexChil + 1 }}</td>
								<td align=center style="padding:4px">{{ itemChil.category_title }}</td>
								<td align=center style="padding:4px">{{ itemChil.goods_name }}</td>
								<td align=center style="padding:4px">{{ itemChil.ck_count }}</td>
							</tr>
						</div>
					</tbody>
				</table>
			</div>
		</div>
		<!-- 打印模板2(含价格) -->
		<div :id="'print-template' + index" v-for="(item, index) in selectionList" :key="index"
			style="position: fixed;top: -9999999px;">
			<div :id="'template-title' + index">
				<div style="line-height: 50px;font-size: 22px;" align=center>
					<strong>
						<font>{{ supplier_info.supplier_name }}配货单</font>
					</strong>
				</div>
				<div style="font-size: 26px;font-weight: 600;left:50px;top:10px;position: absolute;">
					{{ item.phone.slice(-4) }}
				</div>
				<div style="font-size: 26px;font-weight: 600;right:100px;top:10px;position: absolute;">
					{{ item.leader_serial ? item.leader_serial : (index + 1) }}
				</div>
				<table border=0 cellSpacing=0 cellPadding=0 width="90%" style="line-height: 20px;font-size: 14px;">
					<tbody>
						<tr>
							<td style="width:70%">
								<font>提货方式：<span>{{ item.delivery_type == 1 ?
								'配送【' + (item.deliveryline ? item.deliveryline.title : '') + '】,运费' + item.delivery_fee +
								'元,'
								+
								(item.delivery_fee_status == 0 ? '未付' : '已付')
								: '自提' }}</span></font>
							</td>
							<td style="width:30%">
								<font>打印时间：<span>{{ currentDateTime }}</span></font>
							</td>
						</tr>
						<tr>
							<td style="width:70%">
								<font>配货日期：<span>{{ item.date }}</span></font>
							</td>
							<td style="width:30%">
								<font>配送仓库：<span>{{ item.warehouse ? item.warehouse.name : '暂无' }}</span></font>
							</td>

						</tr>
						<tr>
							<td colspan="2">
								<font>收货信息：{{ item.contacts }}-{{ item.phone }}-{{ item.address }}</font>
							</td>
						</tr>
						<tr>
							<td colspan="2">
								<font>备注：{{ item.remark }}</font>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div :id="'template-table' + index">
				<table border=1 cellSpacing=0 cellPadding=1
					:style="'font-size: '+printFontSize+'px;border-collapse:collapse;width:90%'" bordercolor="#333333">
					<thead>
						<tr>
							<td width="7%" style="padding:4px">
								<div align=center><b>序号</b></div>
							</td>
							<td width="13%" style="padding:4px">
								<div align=center><b>商品分类</b></div>
							</td>
							<td width="45%" style="padding:4px">
								<div align=center><b>商品名称</b></div>
							</td>
							<td width="10%" style="padding:4px">
								<div align=center><b>数量</b></div>
							</td>
							<td width="10%" style="padding:4px">
								<div align=center><b>结算价</b></div>
							</td>
							<td width="15%" style="padding:4px">
								<div align=center><b>应结金额</b></div>
							</td>
						</tr>
					</thead>
					<tbody>
						<div v-for="(itemChil, indexChil) in item.goodsList" :key="indexChil">
							<tr>
								<td align=center style="padding:4px;">{{ indexChil + 1 }}</td>
								<td align=center style="padding:4px;">{{ itemChil.category_title }}</td>
								<td align=center style="padding:4px;">{{ itemChil.goods_name }}</td>
								<td align=center style="padding:4px;">{{ itemChil.ck_count }}</td>
								<td align=center style="padding:4px;">{{ itemChil.ck_price }}</td>
								<td align=center style="padding:4px;">
									{{ itemChil.ck_amount }}
								</td>
							</tr>
						</div>

					</tbody>
					<tfoot>
						<tr>
							<td align="center" colspan="2" style="padding:4px;">
								总计:￥ {{ item.goods_amount }} 元
							</td>

							<td align="center" style="padding:4px;">
								<span tdata='pageNO'>##</span>
								<span> / </span>
								<span tdata='pageCount'>##页</span>
							</td>
							<td align="center" tdata="subSum" format="0.00" colspan="3" tindex="6" style="padding:4px;">
								本页小计: ￥ ### 元
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>

		<!-- 配货商品 -->
		<div id="print_summary" style="position: fixed;top: -9999999px;">
			<div class="export-template">
				<div id="template-summary-title">
					<div style="line-height: 50px;font-size: 22px;" align=center>
						<strong>
							<!-- <font>{{ routeName ? routeName : '全部' }}-配送汇总</font> -->
							<font>配货商品汇总</font>
						</strong>
					</div>
				</div>
				<div class="title-box">
					<div class="box-l">
						<div class="l-item">
							<span>打印时间：{{ currentDateTime }}</span>
						</div>
						<div class="l-item">
							<span>配送路线：自选配送单</span>
						</div>
					</div>
				</div>
				<div id="template-summary-table">
					<table border=1 cellSpacing=0 cellPadding=1
						:style="'font-size:'+printFontSize+'px;border-collapse:collapse;width:90%'"
						bordercolor="#333333">
						<thead>
							<tr>
								<td width="7%" style="padding:4px">
									<div align=center><b>序号</b></div>
								</td>
								<td width="13%" style="padding:4px">
									<div align=center><b>商品分类</b></div>
								</td>
								<td width="35%" style="padding:4px">
									<div align=center><b>商品名称</b></div>
								</td>
								<td width="15%" style="padding:4px">
									<div align=center><b>商品卖点</b></div>
								</td>
								<td width="15%" style="padding:4px">
									<div align=center><b>自定义属性</b></div>
								</td>
								<td width="15%" style="padding:4px">
									<div align=center><b>配货数量</b></div>
								</td>
							</tr>
						</thead>
						<tbody>
							<div v-for="(item, index) in summaryTableData" :key="index">
								<tr v-if="item.status == 0">
									<td align=center style="padding:6px 0">{{ index + 1 }}</td>
									<td align=center style="padding:4px;">{{ item.category_title }}</td>
									<td align=center style="padding:6px 0">{{ item.goods_name }}</td>
									<td align=center style="padding:6px 0">{{ item.goods_intro }}</td>
									<td align=center style="padding:6px 0">{{ item.goods_attr }}</td>
									<td align=center style="padding:6px 0">{{ item.count }}</td>
								</tr>
								<tr v-if="item.status != 0 && item.ck_count > 0">
									<td align=center style="padding:6px 0">{{ index + 1 }}</td>
									<td align=center style="padding:4px;">{{ item.category_title }}</td>
									<td align=center style="padding:6px 0">{{ item.goods_name }}</td>
									<td align=center style="padding:6px 0">{{ item.goods_intro }}</td>
									<td align=center style="padding:6px 0">{{ item.goods_attr }}</td>
									<td align=center style="padding:6px 0">{{ item.ck_count }}</td>
								</tr>
							</div>

						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="search">
			<div class="search-l">
				<div class="l-item" style="width: 40%;">
					<div class="item-label">配货日期</div>
					<div class="item-input" style="width: 80%;">
						<el-date-picker v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%;">
						</el-date-picker>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">配货仓库</div>
					<div class="item-input">
						<el-select v-model="searchForm.warehouse_id" placeholder="请选择" style="width: 100%;">
							<el-option v-for="item in warehouseOptions" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">联系人</div>
					<div class="item-input">
						<el-input v-model="searchForm.contacts" placeholder="请输入联系人姓名" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">联系电话</div>
					<div class="item-input">
						<el-input v-model="searchForm.phone" placeholder="请输入联系电话" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">地址</div>
					<div class="item-input">
						<el-input v-model="searchForm.address" placeholder="请输入地址" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">包含商品</div>
					<div class="item-input">
						<el-input v-model="searchForm.goods_name" placeholder="请输入包含商品的名称关键字" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">提货方式</div>
					<div class="item-input">
						<el-select v-model="searchForm.delivery_type" placeholder="请选择提货方式" style="width: 100%;">
							<el-option v-for="item in deliveryTypeList" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label">配送路线</div>
					<div class="item-input">
						<el-select v-model="searchForm.delivery_line_id" placeholder="请选择" style="width: 100%;">
							<el-option v-for="item in routeList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<el-button type="warning" @click.stop="handleSearch">搜索</el-button>
					<el-button
						@click.stop="pageNum = 10, searchForm = {}, dateVal = [getCurrentDate(),getCurrentDate()],handleSearch()">重置</el-button>
				</div>
				<i></i>
				<i></i>
				<i></i>
				<i></i>
			</div>
		</div>
		<div class="table">
			<div class="table-operation">
				<el-button @click.stop="handlePrintSetting"><i class="el-icon-printer"></i></el-button>
				<el-select v-model="printType" placeholder="打印类型" @change="selectPrintType"
					style="margin-right: 10px;width:120px">
					<el-option v-for="item in printTypeList" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<el-button @click.stop="handlePrint" :disabled="selectionList.length == 0">批量打印</el-button>
				<div style="margin:0 10px;display: inline;">
					<el-dropdown @command="handleExport">
						<el-button type="success">
							导出<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>

						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1">按提货人姓名排序</el-dropdown-item>
							<el-dropdown-item command="2">按手机后四位排序</el-dropdown-item>
							<el-dropdown-item command="3">按团长昵称排序</el-dropdown-item>
						</el-dropdown-menu>

					</el-dropdown>
				</div>
				<el-button type="success" @click.stop="handleExportSummary"
					:disabled="selectionList.length == 0">导出配货商品</el-button>
				<el-button type="danger" @click.stop="showSummaryDialog" v-loading.fullscreen.lock="fullscreenLoading"
					:disabled="selectionList.length == 0">配货商品</el-button>
				<el-button type="primary" @click.stop="showPositionDialog"
					v-loading.fullscreen.lock="fullscreenLoading">配送点位</el-button>
				<el-button type="warning" @click.stop="clickRoutePlan">路线规划</el-button>
				<el-button type="info" icon="el-icon-refresh-left" @click.stop="loading = true, getList()"></el-button>
			</div>
			<Table :data="tableData" :total="total" v-loading="loading"
				@size-change="pageNum = $event, loading = true, getList()"
				@current-change="page = $event, loading = true, getList()" @selection-change="selectionChange">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-table :data="props.row.goodsList" style="width: 100%;border:1px solid #e6a23c">
							<el-table-column prop="goods_name" label="商品名称" align="center">
								<template slot-scope="scope">
									<span
										v-if="searchForm.goods_name && scope.row.goods_name.indexOf(searchForm.goods_name) >= 0"
										style="color:#5500ff;font-weight: 600;">{{ scope.row.goods_name }}</span>
									<span v-else>{{ scope.row.goods_name }}</span>
								</template>
							</el-table-column>
							<el-table-column label="商品主图" align="center">
								<template slot-scope="scope">
									<el-image style="width: 50px; height: 50px" :src="scope.row.goods_thumb"
										:preview-src-list="[scope.row.goods_pic]">
									</el-image>
								</template>
							</el-table-column>
							<el-table-column prop="price" label="订单价" align="center"></el-table-column>
							<el-table-column prop="count" label="订单数量" align="center">
								<template slot-scope="scope">
									<span style="color:#67C23A;font-weight: 600;">{{ scope.row.count }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="amount" label="订单金额" align="center"></el-table-column>
							<el-table-column prop="ck_count" label="配货数量" align="center">
								<template slot-scope="scope">
									<span style="color:#409EFF;font-weight: 600;">{{ scope.row.ck_count }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="ck_price" label="结算价" align="center"></el-table-column>
							<el-table-column prop="ck_amount" label="应结金额" align="center"></el-table-column>
						</el-table>
					</template>
				</el-table-column>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column label="配货日期" prop="date" align="center" width="100"></el-table-column>
				<!-- 	<el-table-column label="配货仓库" prop="warehouse.name" align="center" width="120"></el-table-column> -->
				<el-table-column label="配送方式" align="center" width="160">
					<template slot-scope="scope">
						<span
							v-if="scope.row.delivery_type == 2">自提[{{ scope.row.warehouse ? scope.row.warehouse.name : "-" }}]</span>
						<span v-if="scope.row.delivery_type == 1"
							style="color:#E6A23C">配送<br>仓库：{{ scope.row.warehouse ? scope.row.warehouse.name : "-" }}<br>路线：<span
								v-if="scope.row.deliveryline">{{ scope.row.deliveryline.title }}</span><span
								v-else>未设置</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="运费" align="center" width="100">
					<template slot-scope="scope">
						<p>{{ scope.row.delivery_fee }}(<span style="color:#F56C6C"
								v-if="scope.row.delivery_fee_status == 0">未付</span><span style="color:#67C23A"
								v-else>已付</span>)
						</p>
					</template>
				</el-table-column>

				<el-table-column label="下单团长" align="center" width="120">
					<template slot-scope="scope">
						<p>{{ scope.row.leader.username }}</p>
						<p> {{ scope.row.leader.phone }}</p>
					</template>
				</el-table-column>
				<el-table-column prop="leader_serial" sortable="" label="地址序号" align="center"
					width="120"></el-table-column>
				<el-table-column label="收货人" sortable="" align="center" width="120">
					<template slot-scope="scope">
						<p>{{ scope.row.contacts }}</p>
					</template>
				</el-table-column>
				<el-table-column label="收货人电话" align="center" width="120">
					<template slot-scope="scope">
						<p>{{ scope.row.phone }}</p>
					</template>
				</el-table-column>
				<el-table-column label="收货人地址" align="center">
					<template slot-scope="scope">
						<p>{{ scope.row.address }}</p>
					</template>
				</el-table-column>
				<el-table-column label="备注" align="center" width="200">
					<template slot-scope="scope">
						<p>{{ scope.row.remark }}</p>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="180">
					<template slot-scope="scope">
						<el-button type="success" size="mini" @click.stop="handlePrint(scope.row)">打印</el-button>
						<el-button type="warning" size="mini" @click.stop="handleAddress(scope.row)">改地址</el-button>
						<!-- <el-button type="danger" size="mini" v-if="scope.row.status == 0"
                            @click.stop="handleStatus(scope.row, 9)">取消</el-button> -->
					</template>
				</el-table-column>
			</Table>
		</div>
		<!-- 修改地址 -->
		<el-dialog title="修改地址" :visible.sync="addressDialog" :close-on-click-modal="false" v-el-drag-dialog
			width="30%">
			<el-form ref="form" :model="addressForm" label-width="80px">
				<el-form-item label="收货人">
					<el-input v-model="addressForm.contacts" placeholder="请输入收货人" />
				</el-form-item>
				<el-form-item label="联系电话">
					<el-input v-model="addressForm.phone" placeholder="请输入联系电话" />
				</el-form-item>
				<el-form-item label="详细地址">
					<el-input v-model="addressForm.address" placeholder="请输入详细地址" />
				</el-form-item>
				<el-form-item label="配送路线" v-if="addressForm.delivery_type == 1">
					<el-select v-model="addressForm.delivery_line_id" placeholder="请选择配送路线" style="width: 100%;"
						@focus="getRouteList()">
						<el-option v-for="item in addressRouteLine" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click.stop="addressDialog = false">取 消</el-button>
				<el-button type="primary" @click.stop="addressConfirmFn" v-loading.fullscreen.lock="fullscreenLoading">确
					定</el-button>
			</span>
		</el-dialog>
		<!-- 路线规划 -->
		<el-dialog title="路线规划" :visible.sync="routePlannDialog" :close-on-click-modal="false" v-el-drag-dialog
			width="30%">
			<el-form ref="form" :model="routePlannForm" label-width="80px">
				<el-form-item label="配送仓库">
					<el-select v-model="routePlannForm.warehouse_id" placeholder="请选择配送仓库"
						@change="changeRoutePlanWarehouse" style="width: 100%;">
						<el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属路线" v-if="selectionList.length == 0">
					<el-select v-model="routePlannForm.delivery_line_id" placeholder="请选择所属路线" style="width: 100%;">
						<el-option v-for="item in routeList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="配货日期" v-if="selectionList.length == 0">
					<el-date-picker v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%;">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="路线计算">
					<el-radio-group v-model="routePlannForm.force">
						<el-radio label="0">不重新计算</el-radio>
						<el-radio label="1">重新计算路线</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click.stop="routePlannDialog = false">取 消</el-button>
				<el-button type="primary" @click.stop="routePlannConfirmFn"
					v-loading.fullscreen.lock="fullscreenLoading">确
					定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="路线规划" :visible.sync="mapDialog" :close-on-click-modal="false" v-el-drag-dialog width="80%"
			:fullscreen="true" @close="closeDialog">
			<div class="map-dialog">
				<div class="dialog-l">
					<div style="position: relative;">
						<div class="l-select">
							<p>行车路径：</p>
							<el-select v-model="routePlannType" placeholder="请选择行车路径" @change="changeRoutePlann">
								<el-option v-for="item in routePlannList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</div>
						<div class="qrcode-range">
							<div id="qrcode" ref="qrcode" style="padding:10px">

							</div>
							<span style="padding-bottom:10px;font-size:14px">微信扫一扫</span>
						</div>
					</div>
					<div id="mapContainer" style="width:100%; height:93%"></div>
				</div>


				<div class="dialog-r">
					<el-tabs value="normalList" style="max-height:800px">
						<el-tab-pane :label="normalName" name="normalList">
							<div class="r-item">
								<div class="item-title"><span
										style="color:green;font-weight: 600;">起点</span>：{{ routePlannForm.warehouse_name }}
								</div>
							</div>
							<div class="r-item"
								v-for="(item, index) in routePlannType == 1 ? mapData.short : mapData.fast"
								:key="index">
								<div class="item-title"><span style="color:blue;font-weight: 600;">第{{ index + 1 }}站
									</span>：{{ item.contacts }}
									{{ item.phone }}
								</div>
								<div class="item-address">地址：{{ item.address }}</div>
								<div class="item-address">共 {{ item.distance }} ，大约需要 {{ item.duration }}</div>
							</div>
							<div class="r-item">
								<div class="item-title" v-if="routePlannType == 1 "><span
										style="color:red;font-weight: 600;">结束</span>：总里程
									{{ mapData.totalShortDistance }} ，共需要 {{ mapData.totalShortDuration }}
								</div>
								<div class="item-title" v-else><span style="color:red;font-weight: 600;">结束</span>：总里程
									{{ mapData.totalFastDistance }} ，共需要 {{ mapData.totalFastDuration }}
								</div>
							</div>
						</el-tab-pane>
						<el-tab-pane :label="errName" name="errList">
							<div class="r-item" v-for="(item, index) in mapData.errList" :key="index">
								<div class="item-title"><span
										style="color:red;font-weight: 600;">第{{ index + 1 }}个</span>：{{ item.contacts }}
									{{ item.phone }}
								</div>
								<div class="item-address">地址：{{ item.address }}</div>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="配送点位" :visible.sync="positionDialog" :close-on-click-modal="false" v-el-drag-dialog
			width="80%" :fullscreen="true" @close="closePositionDialog">
			<div class="map-dialog">
				<div id="positionContainer" style="width:100%; height:93%"></div>
			</div>
		</el-dialog>
		<el-dialog title="配货商品" :visible.sync="summaryDialog" :close-on-click-modal="false" v-el-drag-dialog width="80%"
			@close="closeSummaryDialog">
			<div class="summary-dialog">
				<el-table :data="summaryTableData" style="width: 100%" border :header-cell-style="{
					background: '#f5f7fa',
					fontWeight: 'bold',
					color: '#303133'
				}" v-loading="loading">
					<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
					<el-table-column label="状态" align="center" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.status == 0">待确认</span>
							<span v-if="scope.row.status == 1" style="color:#67C23A">已确认</span>
							<span v-if="scope.row.status == 2" style="color:#F56C6C">已延期</span>
							<span v-if="scope.row.status == 9">已取消</span>
						</template>
					</el-table-column>
					<el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
					<el-table-column label="商品主图" align="center">
						<template slot-scope="scope">
							<el-image style="width: 50px; height: 50px" :src="scope.row.goods_thumb"
								:preview-src-list="[scope.row.goods_pic]">
							</el-image>
						</template>
					</el-table-column>
					<el-table-column prop="goods_intro" label="商品卖点" align="center"></el-table-column>
					<el-table-column prop="goods_attr" label="自定义属性" align="center"></el-table-column>
					<el-table-column prop="price" label="单价" sortable="" align="center"></el-table-column>
					<el-table-column prop="ck_count" label="配货数量" sortable="" align="center"></el-table-column>
					<el-table-column prop="ck_amount" label="应结金额" sortable="" align="center"></el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click.stop="handlePrintSummary"
					v-loading.fullscreen.lock="fullscreenLoading">打
					印</el-button>
				<el-button type="success" @click.stop="handleExportSummary"
					v-loading.fullscreen.lock="fullscreenLoading">导
					出</el-button>
				<el-button type="info" @click.stop="closeSummaryDialog">关 闭</el-button>
			</span>
		</el-dialog>
		<!-- 打印设置 -->
		<PrintSetting :printSetDialog="printSetDialog" @callback="printSetting"></PrintSetting>
	</div>

</template>

<script>
	import QRCode from 'qrcodejs2'
	import {
		getLodop
	} from '@/utils/CLodopfuncs.js'
	import PrintSetting from "../../components/printSetting/index.vue";
	export default {
		components: {
			'PrintSetting': PrintSetting,
		},
		data() {
			return {
				currentDateTime: this.getCurrentDateTime(),
				imageUrl: "https://static-th.howtec.cc/images/logo.png",
				normalName: "配送站点",
				errName: "异常地址",
				dateVal: [],
				searchForm: {
					begin: '',
					end: '',
					warehouse_id: ''
				},
				warehouseOptions: [],
				tableData: [],
				loading: true,
				page: 1,
				pageNum: 10,
				total: 0,
				orderDate: '',
				// 提货方式
				deliveryTypeList: [{
						id: 1,
						name: '自提'
					},
					{
						id: 2,
						name: '配送'
					}
				],
				warehouseList: [], //仓库
				routeList: [], //配送路线
				// 供应商信息
				supplier_info: {},
				// 选择表格的数据
				selectionList: [],
				// 路线规划
				mapData: {
					short: [],
					fast: []
				},
				routePlannForm: {
					warehouse_name: "",
					delivery_type: 2,
					begin: '',
					end: '',
					force: '0',
				},
				routePlannDialog: false,
				mapDialog: false,
				routePlannType: 1,
				routePlannList: [{
						id: 1,
						name: '最短距离'
					},
					{
						id: 2,
						name: '最快时间'
					}
				],
				fullscreenLoading: false,
				mapKey: "",
				qrcode: null,
				positionDialog: false,
				summaryDialog: false,
				summaryTableData: [],
				//修改地址
				addressForm: {},
				addressDialog: false,
				addressRouteLine: [],
				//打印纸
				printSetDialog: false,
				printFontSize: 14,
				pageType: 1,
				pageTypeItem: {
					id: 1,
					name: '针式三等分多联纸',
					width: 2410,
					height: 930
				},
				printMode: 1,
				mapPosition: null,
				printType: 1,
				printTypeItem: {
					id: 1,
					name: '不含价格',
				},
				printTypeList: [{
					id: 1,
					name: '不含价格',
				}, {
					id: 2,
					name: '含价格',
				}],
				marker: null
			}
		},
		mounted() {
			this.supplier_info = JSON.parse(sessionStorage.getItem('supplier_info'))
			// 列表
			this.getList()
			// 时间
			this.dateVal = [this.getCurrentDate(), this.getCurrentDate()]
			this.searchForm.begin = this.dateVal[0]
			this.searchForm.end = this.dateVal[1]
			this.routePlannForm.begin = this.dateVal[0]
			this.routePlannForm.end = this.dateVal[1]
			this.routePlannForm.force = '0'
			// 路线
			this.getRouteList()
			// 仓库
			this.getWarehouse()
			// 检查是否有未配商品
			this.checkNoDelivery()
			this.getWarehouseList()
			this.pageType = localStorage.getItem("defaultPageType") ?? '1';
			this.pageType = Number(this.pageType)
			if (localStorage.getItem("defaultPageTypeItem")) {
				this.pageTypeItem = JSON.parse(localStorage.getItem("defaultPageTypeItem"));
			} else {
				this.pageTypeItem = {
					id: 1,
					name: '针式三等分多联纸',
					width: 2410,
					height: 930
				};
			}
			if (localStorage.getItem("printFontSize")) {
				this.printFontSize = localStorage.getItem("printFontSize")
			}
		},
		methods: {
			handleSearch() {
				if (this.loading) return;
				this.loading = true
				this.page = 1
				this.searchForm.begin = this.dateVal[0]
				this.searchForm.end = this.dateVal[1]
				this.getList()
				//window.localStorage.setItem("searchForm", this.searchForm)
			},
			handlePrintSetting() {
				this.printSetDialog = true
			},
			printSetting(res) {
				this.printFontSize = res.fontSize
				this.pageType = res.pageType
				this.pageTypeItem = res.pageTypeItem
				this.printSetDialog = false
			},
			selectPrintType(value) {
				let that = this
				this.printTypeList.forEach(item => {
					if (item.id == value) {
						that.printTypeItem = item
					}
				})
			},
			checkNoDelivery() {
				this.$http.post(`erp/v1/preck/check_no_delivery`, {}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200 && data > 0) {

						this.$alert('今日有' + data + '件商品未生成配送单，请重新生成', '警告', {
							confirmButtonText: '确定',
							callback: action => {

							}
						});
					}
				});
			},
			handleAddress(item) {
				this.addressForm = {
					contacts: item.contacts,
					phone: item.phone,
					address: item.address,
					delivery_line_id: item.delivery_line_id,
					delivery_type: item.delivery_type,
					pre_ckd_ids: item.pre_ckd_ids,
				}
				this.addressRouteLine.push({
					id: 0,
					title: "未设置",
				})
				this.addressDialog = true;
			},
			addressConfirmFn() {
				this.$http.post(`erp/v1/preck/modify_address`, {
					...this.addressForm
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.$message.success(msg)
						this.addressForm = {}
						this.addressDialog = false
						this.getList()
					} else {
						this.$message.error(msg);
					}
				});
			},
			showSummaryDialog() {
				let preCkdIds = "";
				this.selectionList.forEach(item => {
					preCkdIds = preCkdIds + item.pre_ckd_ids + ","
				})
				this.summaryDialog = true
				this.$http.post(`erp/v1/preck/summary`, {
					pre_ckd_ids: preCkdIds,
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.summaryTableData = data
					} else {
						this.$message.error(msg);
					}
				});
			},
			handleExportSummary() {
				this.loading = true
				let preCkdIds = "";
				this.selectionList.forEach(item => {
					preCkdIds = preCkdIds + item.pre_ckd_ids + ","
				})
				this.$http.post(`erp/v1/preck/summary`, {
					pre_ckd_ids: preCkdIds,
					export: 1,
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						window.open(data.url)
					} else {
						this.$message.error(msg);
					}
				});
			},
			closeSummaryDialog() {
				this.summaryDialog = false
			},
			handlePrintSummary() {
				setTimeout(() => {
					var LODOP = getLodop();
					var titleStyle =
						"<style> .title-box{display: flex;justify-content: space-between;margin-bottom:10px} .title-box .box-l{display: flex;justify-content: space-between} .title-box .l-item {line-height: 22px;} .title-box .l-item span {padding-right: 30px;} .title-box .bold{font-weight: bold;} .box-r img {width: 100px;height: 100px;}</style>"
					LODOP.ADD_PRINT_HTM(2, "5%", "90%", 1000, titleStyle + document.getElementById("print_summary")
						.innerHTML);
					LODOP.PREVIEW()
					LODOP.NewPageA();
				}, 500);
			},
			showPositionDialog() {
				this.fullscreenLoading = true
				let preCkdIds = "";
				this.selectionList.forEach(item => {
					preCkdIds = preCkdIds + item.pre_ckd_ids + ","
				})

				this.$http.post(`/erp/v1/preck/lst_address_lng_lat`, {
					'pre_ckd_ids': preCkdIds,
					...this.searchForm,
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						this.fullscreenLoading = false;
						this.positionDialog = true
						let addressData = data.addressList
						let mapGeometries = []
						let warehouse = {
							lat: "",
							lng: ""
						}
						this.mapKey = data.mapKey

						addressData.forEach((item, index) => {
							mapGeometries.push({
								styleId: 'marker',
								position: new TMap.LatLng(item.lat, item.lng),
								content: item.contacts
							})
							warehouse.lat = item.warehouse.lat
							warehouse.lng = item.warehouse.lng

						})

						// 地图
						this.$nextTick(() => {
							if (this.mapPosition == null) {
								this.mapPosition = new TMap.Map('positionContainer', {
									zoom: 12,
									disableDefaultUI: true,
								});
							}
							this.mapPosition.setCenter(new TMap.LatLng(warehouse.lat, warehouse.lng))
							if (!this.marker) {
								this.marker = new TMap.MultiMarker({
									id: 'marker-layer1',
									map: this.mapPosition,
									styles: {
										marker: new TMap.MarkerStyle({
											width: 20,
											height: 28,
											direction: 'top',
										})

									},
									geometries: mapGeometries,
								});
							} else {
								this.marker.setGeometries(mapGeometries)
							}

						})

					} else {
						this.$message.error(msg);
					}
				});


			},
			closePositionDialog() {
				this.positionDialog = false
			},
			GenerateQRCode() {
				if (this.qrcode == null) {
					this.qrcode = new QRCode(this.$refs.qrcode, {
						width: 128, // 二维码宽度，单位像素
						height: 128, // 二维码高度，单位像素
						text: "https://tuanhuo.howtec.cc/driving_line?key=" + this.mapData.driverKey + "&expire=" +
							this.mapData.driverKeyExpire, // 生成二维码的链接
					})
				} else {
					this.qrcode.makeCode("https://tuanhuo.howtec.cc/driving_line?key=" + this.mapData.driverKey +
						"&expire=" +
						this.mapData.driverKeyExpire)
				}

			},

			// 获取当前年月日
			getCurrentDate() {
				const today = new Date();
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			getList() {
				this.$http.post(`/erp/v1/preck/lst_address`, {
					page: this.page,
					pageNum: this.pageNum,
					...this.searchForm
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.tableData = data.rows
						this.total = data.total
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 选择表格数据
			selectionChange(e) {
				this.selectionList = e
			},
			// 打印
			handlePrint(item) {
				if (item.pre_ckd_ids) {
					this.selectionList = []
					this.selectionList.push(item)
					this.printMode = 1
				} else {
					if (this.selectionList.length <= 0) {
						this.$message.error('请选择数据');
						return
					}
					this.printMode = 2
				}
				let that = this
				setTimeout(() => {
					var LODOP = getLodop();
/* 					if (that.pageType < 4) {
						var tableTop = 140
					} else {
						var tableTop = 160
					} */
					var tableTop = 140
					var totalPrint = 0
					for (var i = 0; i < this.selectionList.length; i++) {
						totalPrint++

						if (that.printType == 1) {
							var parentDiv = document.getElementById('export-template' + i);
						} else {
							var parentDiv = document.getElementById('print-template' + i);
						}

						var strStyle =
							"<style> table,td,th {border-width: 1px;border-style: solid;border-collapse: collapse}</style>"

						LODOP.SET_PRINT_PAGESIZE(0, this.pageTypeItem.width, this.pageTypeItem
							.height);

						/* 						LODOP.ADD_PRINT_TABLE(tableTop, 30, "100%", "100%",
													strStyle + parentDiv
													.querySelector("#template-table" + i).innerHTML);
												LODOP.ADD_PRINT_HTM(2, 30, "100%", tableTop, parentDiv
													.querySelector(
														"#template-title" + i).innerHTML); */
						LODOP.ADD_PRINT_TABLE(tableTop, 20, "RightMargin:20", "BottomMargin:20",
							strStyle + parentDiv
							.querySelector("#template-table" + i).innerHTML);
						LODOP.ADD_PRINT_HTM(2, 20, "RightMargin:20", "BottomMargin:20", parentDiv
							.querySelector(
								"#template-title" + i).innerHTML);
						LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
						LODOP.SET_PRINT_STYLEA(0, "LinkedItem", -1);
						LODOP.NewPageA();

						/* LODOP.SET_PRINT_PAGESIZE(0, this.pageTypeItem.width, this.pageTypeItem
							.height, this.pageTypeItem.name);

						LODOP.ADD_PRINT_HTM(2, "5%", "90%", 140, document.getElementById(
							"template-title" + i).innerHTML);
						if (this.printMode == 1) {
							LODOP.SET_PRINT_STYLEA(0, "ItemType",
								1); //ItemType:设置上面的为页眉页脚，每页固定位置输出
						}
						var strStyle =
							"<style> table,td,th {border-width: 1px;border-style: solid;border-collapse: collapse;}</style>"
						LODOP.ADD_PRINT_TABLE(140, "5%", "90%", "100%", strStyle + document
							.getElementById("template-table" + i).innerHTML);
						LODOP.NewPageA(); */
						if (totalPrint == this.selectionList.length) {
							LODOP.PREVIEW()
						}
					}
					this.getList()
					this.selectionList = []
				}, 500);
			},
			// 导出
			handleExport(sort) {
				this.loading = true
				this.$http.post(`/erp/v1/preck/lst_address`, {
					page: this.page,
					pageNum: this.pageNum,
					...this.searchForm,
					export: 1,
					export_sort: sort,
					hasPrice: this.printType
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						window.open(data.url, '_self')
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 导出
			handleExportSummary() {
				this.loading = true
				let ckdIds = ""
				if (this.selectionList.length > 0) {
					this.selectionList.forEach(i => {
						ckdIds = ckdIds + i.pre_ckd_ids + ","
					})
				}
				this.$http.post(`/erp/v1/preck/summary`, {
					page: this.page,
					pageNum: this.pageNum,
					...this.searchForm,
					export: 1,
					pre_ckd_ids: ckdIds
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						window.open(data.url, '_self')
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 所属路线
			getRouteList() {
				this.$http.post(`erp/v1/delivery_line/all`).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						this.routeList = data
						this.addressRouteLine = data
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 仓库
			getWarehouse() {
				this.$http.post(`erp/v1/warehouse/all`, {
					pageNum: 100
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						this.warehouseList = data
					} else {
						this.$message.error(msg);
					}
				});
			},
			//选中路线规划的起始点
			changeRoutePlanWarehouse(id) {
				let that = this
				this.warehouseList.forEach((item, index) => {
					if (item.id == id) {
						that.routePlannForm.warehouse_name = item.name
					}
				})

			},
			clickRoutePlan() {
				this.routePlannDialog = true
			},
			// 路线规划确定
			routePlannConfirmFn() {
				let preCkdIds = "";
				this.selectionList.forEach(item => {
					preCkdIds = preCkdIds + item.pre_ckd_ids + ","
				})

				if (!this.routePlannForm.warehouse_id) {
					this.$message.error('请选择配送仓库');
					return
				}

				if (preCkdIds == "" && !this.routePlannForm.delivery_line_id) {
					this.$message.error('请选择所属路线');
					return
				}
				this.fullscreenLoading = true;
				this.routePlannForm.begin = this.dateVal[0]
				this.routePlannForm.end = this.dateVal[1]
				this.$http.post(`/erp/v1/preck/lst_map`, {
					pre_ckd_ids: preCkdIds,
					...this.routePlannForm
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						this.fullscreenLoading = false;
						this.routePlannDialog = false
						if (data == undefined || data == null || data.length == 0) {
							this.$message.success(msg);
							return;
						}
						this.mapDialog = true
						this.mapData = data
						this.mapKey = data.mapKey


						let routePlannArr = []
						if (this.routePlannType == 1) {
							routePlannArr = this.mapData.short
						} else {
							routePlannArr = this.mapData.fast
						}
						this.normalName = "配送站点（" + data.short.length + "）"
						this.errName = "异常地址（" + data.errList.length + "）"
						// 结束位置
						let end = routePlannArr[routePlannArr.length - 1]
						// 途经点
						let passingPoint = routePlannArr.map(i => {
							return `${i.lat}` + ',' + `${i.lng};`;
						}).join('');
						passingPoint = passingPoint.substring(0, passingPoint.lastIndexOf(';'));
						// 地图轨迹
						let geometries = []
						//起点
						geometries.push({
							styleId: 'start',
							position: new TMap.LatLng(this.mapData.start.lat, this.mapData.start
								.lng),
							content: this.routePlannForm.warehouse_name
						})
						routePlannArr.forEach((item, index) => {
							if (index < routePlannArr.length - 1) {
								geometries.push({
									styleId: 'marker',
									position: new TMap.LatLng(item.lat, item.lng),
									content: '第' + (index + 1) + '站'
								})
							}

						})
						//终点
						geometries.push({
							styleId: 'end',
							position: new TMap.LatLng(routePlannArr[routePlannArr.length - 1].lat,
								routePlannArr[routePlannArr.length - 1].lng),
							content: '第' + (routePlannArr.length) + '站'
						})
						// 地图
						this.$nextTick(() => {
							this.GenerateQRCode()

							window.map = new TMap.Map('mapContainer', {
								center: new TMap.LatLng(this.mapData.start.lat, this.mapData.start
									.lng), //自己的定位纬度 经度,
								zoom: 12,
								disableDefaultUI: true,
							});
							var url =
								`https://apis.map.qq.com/ws/direction/v1/driving/?from=${this.mapData.start.lat},${this.mapData.start.lng}&to=${end.lat},${end.lng}&output=jsonp&waypoints=${passingPoint}&callback=cb&key=${this.mapKey}`;
							//发起JSONP请求，获取路线规划结果
							this.jsonp_request(url);
							var marker = new TMap.MultiMarker({
								id: 'marker-layer',
								map: map,
								styles: {
									marker: new TMap.MarkerStyle({
										width: 28,
										height: 28,
										direction: 'top',
										src: 'https://static-th.howtec.cc/miniprogram/common/tujing.png'
									}),
									start: new TMap.MarkerStyle({
										width: 28,
										height: 28,
										direction: 'top',
										src: 'https://static-th.howtec.cc/miniprogram/common/start.png'
									}),
									end: new TMap.MarkerStyle({
										width: 28,
										height: 28,
										direction: 'top',
										src: 'https://static-th.howtec.cc/miniprogram/common/end.png'
									}),
								},
								geometries: geometries,
							});
						})
					} else {
						this.$message.error(msg);
					}
				});
			},
			jsonp_request(url) {
				var script = document.createElement('script');
				script.src = url;
				document.body.appendChild(script);
			},
			// 切换路线轨迹
			changeRoutePlann(e) {
				window.map.destroy()
				this.routePlannType = e
				this.routePlannConfirmFn()
			},
			// 关闭地图弹窗
			closeDialog() {
				window.map.destroy()
			},
			// 获取当前年月日时分秒
			getCurrentDateTime() {
				const now = new Date();
				const year = now.getFullYear();
				const month = this.padNumber(now.getMonth() + 1); // 月份是从0开始的
				const day = this.padNumber(now.getDate());
				const hours = this.padNumber(now.getHours());
				const minutes = this.padNumber(now.getMinutes());
				const seconds = this.padNumber(now.getSeconds());
				return (
					year +
					'-' +
					month +
					'-' +
					day +
					' ' +
					hours +
					':' +
					minutes +
					':' +
					seconds
				);
			},
			padNumber(num) {
				return num < 10 ? '0' + num : num;
			},
			// 仓库
			getWarehouseList() {
				this.$http.post(`erp/v1/warehouse/all`).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.warehouseOptions = data
					} else {
						this.$message.error(msg);
					}
				});
			},
		},
	}
</script>

<style lang="scss" scoped>
	.map-dialog {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: space-between;

		.dialog-l {
			width: 80%;
			height: 100%;

			.l-select {
				display: flex;
				align-items: center;
				margin-bottom: 10px;
			}
		}

		.dialog-r {
			width: 18%;
			display: flex;
			flex-direction: column;
			overflow-y: auto;

			.r-item {
				margin-bottom: 10px;
			}
		}
	}

	.qrcode-range {
		left: 20px;
		top: 80px;
		position: absolute;
		display: flex;
		background-color: #fff;
		z-index: 999;
		color: #000;
		flex-direction: column;
		text-align: center;
	}
</style>